export default "__VITE_ASSET__DAQE4nmq__";